// extracted by mini-css-extract-plugin
export default {"btnStyles":"Button_btnStyles__MuZY3","container":"Button_container__Q7Zgb"};